/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const GitBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="m12.935 1.896 9.169 9.169a1.353 1.353 0 0 1 0 1.913l-9.126 9.126a1.353 1.353 0 0 1-1.913 0l-9.169-9.169a1.353 1.353 0 0 1 0-1.913l9.126-9.126a1.352 1.352 0 0 1 1.913 0Zm7.297 10.125-8.21 8.21-8.254-8.252 5.829-5.83.967.968a1.61 1.61 0 0 0 .873 2.11v5.766a1.61 1.61 0 1 0 1.324.047V9.327l2.17 2.171a1.61 1.61 0 1 0 .964-.907l-2.327-2.328a1.607 1.607 0 0 0-2.034-2.048l-1.001-1 1.446-1.447 8.253 8.253Z" /></svg>);
const Git = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={GitBase} {...rest} ref={ref} />);
export default Git;